var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2154_39051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.24 4.608 7.258 8.592 3.272 4.608a.54.54 0 0 0-.39-.164.54.54 0 0 0-.391.164.546.546 0 0 0 0 .776l4.375 4.375c.105.105.239.157.39.157a.55.55 0 0 0 .386-.157l4.369-4.375a.546.546 0 0 0 0-.776.56.56 0 0 0-.385-.164.53.53 0 0 0-.385.164"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2154_39051"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.333 9.916V4.444h9.841v5.472z"
  })))));
};
export default SvgArrowDown;